// src/services/seoService.js
import API_BASE_URL from "../config/apiConfig";
import createApiClient from "../config/apiClient";

const apiClient = createApiClient(API_BASE_URL);
const API_URL = "/seo";

// ========== ADMIN ROUTES ==========

// Lấy danh sách SEO cho admin
export const getAllSeo = async (params = {}) => {
  try {
    const response = await apiClient.get(`${API_URL}/admin`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching SEO list:', error);
    throw error;
  }
};

// Lấy thông tin SEO theo ID cho admin
export const getSeoById = async (id) => {
  try {
    const response = await apiClient.get(`${API_URL}/admin/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching SEO by ID:', error);
    throw error;
  }
};

// Tạo SEO mới
export const createSeo = async (data) => {
  try {
    const response = await apiClient.post(`${API_URL}/admin`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating SEO:', error);
    throw error;
  }
};

// Cập nhật SEO
export const updateSeo = async (id, data) => {
  try {
    const response = await apiClient.put(`${API_URL}/admin/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating SEO:', error);
    throw error;
  }
};

// Xóa SEO
export const deleteSeo = async (id) => {
  try {
    const response = await apiClient.delete(`${API_URL}/admin/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting SEO:', error);
    throw error;
  }
};

// ========== CUSTOMER ROUTES ==========

// Lấy thông tin SEO theo route cho customer
export const getSeoByRoute = async (route) => {
  try {
    // Normalize route: đảm bảo bắt đầu với /
    const normalizedRoute = route.startsWith('/') ? route : `/${route}`;
    // Gửi route như query parameter thay vì path parameter
    // Axios sẽ tự động encode query params
    const response = await apiClient.get(`${API_URL}/customer/route`, {
      params: { route: normalizedRoute },
      paramsSerializer: {
        // Đảm bảo route được encode đúng cách
        encode: (param, key) => {
          if (key === 'route') {
            return encodeURIComponent(param);
          }
          return param;
        }
      }
    });
    // Đảm bảo response.data tồn tại và hợp lệ
    if (!response || !response.data) {
      return { success: false, data: null };
    }
    return response.data;
  } catch (error) {
    // Không log error nếu là 404 (route không tồn tại là bình thường)
    if (error.response?.status === 404) {
      return { success: false, data: null };
    }
    // Xử lý trường hợp response.data là undefined
    if (error.response && !error.response.data) {
      return { success: false, data: null };
    }
    console.error('Error fetching SEO by route:', error);
    throw error;
  }
};
